/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// re-export everything from semi ui
// Keep the named export here. When those components need to be modified in the future, you can modify the supplementary file.
export {
  Anchor,
  AutoComplete,
  Avatar,
  AvatarGroup,
  BackTop,
  Badge,
  Banner,
  Breadcrumb,
  // The name FIXME: Button has been taken by the upper layer. You need to fix all the places where the upper layer is called before exporting this component.
  // Button,
  ButtonGroup,
  Calendar,
  Card,
  CardGroup,
  Carousel,
  Cascader,
  Checkbox,
  CheckboxGroup,
  Collapse,
  Collapsible,
  ConfigProvider,
  DatePicker,
  Descriptions,
  Divider,
  Empty,
  Modal,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownDivider,
  Row,
  Col,
  Layout,
  List,
  IconButton,
  Icon,
  // FIXME: The name Input is already occupied by the upper layer. You need to fix all the places where the upper layer is called before exporting this component.
  // Input,
  InputGroup,
  TextArea,
  InputNumber,
  Nav,
  NavItem,
  SubNav,
  Notification,
  OverflowList,
  Pagination,
  Popconfirm,
  Popover,
  Progress,
  Radio,
  RadioGroup,
  Rating,
  ScrollList,
  ScrollItem,
  Select,
  SideSheet,
  Skeleton,
  Slider,
  Space,
  Spin,
  SplitButtonGroup,
  Step,
  Steps,
  Switch,
  Table,
  Tabs,
  TabPane,
  Tag,
  TagGroup,
  TagInput,
  Timeline,
  TimePicker,
  Toast,
  ToastFactory,
  Tooltip,
  Tree,
  TreeSelect,
  Upload,
  Typography,
  Transfer,
  Highlight,
  LocaleProvider,
  LocaleConsumer,
  Image,
  ImagePreview,
} from '@douyinfe/semi-ui';

export {
  Form,
  useFormApi,
  useFormState,
  useFieldApi,
  useFieldState,
  withFormState,
  withFormApi,
  withField,
  ArrayField,
} from '@douyinfe/semi-ui/lib/es/form';

export { zhCN, zhHK, zhTW, enUS } from './locale';
